<dx-chart id="chart" [dataSource]="consegneMensili">
  <dxi-series
    argumentField="descrizione"
    valueField="val"
    name="Consegne mensili"
    type="bar"
    color="#ffaa66"
    >
  </dxi-series>

  <!-- Linea orizzontale al valore medio -->
  <dxo-value-axis>
    @if (mediaValori != null) {
      <dxi-constant-line
        [value]="mediaValori"
        color="red"
        dashStyle="dash"
        width="2">
        <dxo-label
          [text]=" 'Media: ' + mediaValori"
          position="outside"
          horizontalAlignment="right">
        </dxo-label>
      </dxi-constant-line>
    }
  </dxo-value-axis>
  <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" >
  </dxo-legend>
  <dxo-export [enabled]="false"></dxo-export>
  <dxo-title [text]="titleChart">
    <dxo-subtitle text=""></dxo-subtitle>
  </dxo-title>
</dx-chart>
